import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { environment } from '@environments/environment';

@Injectable()
export class RoleGuard implements CanActivate {

  route: any;
  constructor(
    private router:Router
    ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    let userType = localStorage.getItem('userType').replace(/\s/g, "")
    let roles = route.data["roles"];

    // if yung list of roles may nag equal sa userType
    if(roles.indexOf(userType) >= 0){
      return true;
    }

    if(userType == 'SystemAdministrator'){
        this.router.navigateByUrl(environment.systemAdmin_home)
    }else {
        this.router.navigateByUrl(environment.frontliner_home)
    }
    return false
  }


} 